import { render, staticRenderFns } from "./msgToolBtn.vue?vue&type=template&id=0aa9d5a3"
import script from "./msgToolBtn.vue?vue&type=script&lang=js"
export * from "./msgToolBtn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports